var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 306,
    viewBox: "0 0 460 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.922 129.932C298.803 129.932 296.733 129.306 294.972 128.132C293.21 126.959 291.838 125.291 291.027 123.34C290.217 121.389 290.004 119.242 290.418 117.171C290.831 115.1 291.851 113.197 293.349 111.704C294.847 110.21 296.755 109.193 298.832 108.781C300.91 108.369 303.063 108.581 305.02 109.389C306.977 110.197 308.65 111.566 309.827 113.322C311.004 115.078 311.632 117.142 311.632 119.254C311.632 122.086 310.503 124.802 308.495 126.804C306.486 128.807 303.762 129.932 300.922 129.932Z",
    fill: "#FFE0BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.273 202.54L355.784 197.059L349.84 202.985L355.784 197.059L349.84 202.985L345.922 199.079C345.121 198.279 344.169 197.645 343.121 197.212C342.074 196.78 340.951 196.557 339.817 196.557C338.684 196.557 337.561 196.78 336.513 197.212C335.466 197.645 334.514 198.279 333.713 199.079C329.938 202.841 324.937 205.13 319.615 205.53C314.293 205.93 309.004 204.414 304.707 201.259L279.958 183.08C272.056 177.281 266.234 169.102 263.352 159.751C260.471 150.4 260.682 140.372 263.955 131.15L264.393 129.905C267.073 122.339 271.418 115.467 277.111 109.795L294.488 92.47C300.175 86.7988 307.064 82.4691 314.649 79.7988C316.477 79.1485 318.347 78.6196 320.245 78.2151L221.794 -0.0268555L79.709 112.838V295.82H363.87V202.193L361.273 202.54Z",
    fill: "#FFE0BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M206.246 73.1348L80.717 118.516C74.1561 120.888 68.1978 124.667 63.2628 129.588C58.3279 134.508 54.5367 140.449 52.1572 146.99L6.64006 272.152C-0.660539 292.235 18.8583 311.695 39.0108 304.417L164.54 259.036C171.1 256.662 177.058 252.882 181.993 247.962C186.928 243.042 190.719 237.102 193.1 230.562L238.617 105.409C245.909 85.3165 226.399 65.8205 206.246 73.1348ZM223.498 101.217C222.207 102.503 220.563 103.378 218.773 103.733C216.983 104.087 215.128 103.905 213.442 103.208C211.757 102.511 210.316 101.332 209.302 99.819C208.288 98.3061 207.747 96.5275 207.747 94.7082C207.747 92.8888 208.288 91.1106 209.302 89.5978C210.316 88.0849 211.757 86.9055 213.442 86.2088C215.128 85.5122 216.983 85.3292 218.773 85.6835C220.563 86.0378 222.207 86.9133 223.498 88.1992C224.356 89.0537 225.037 90.0685 225.501 91.1854C225.965 92.3022 226.204 93.4992 226.204 94.7082C226.204 95.9172 225.965 97.1145 225.501 98.2314C225.037 99.3482 224.356 100.363 223.498 101.217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.753 129.887C300.556 126.4 300.949 122.831 300.922 119.253",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.557 94.0806C185.22 121.327 226.569 151.919 261.43 153.814H261.956",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.922 129.932C298.803 129.932 296.733 129.306 294.972 128.132C293.21 126.959 291.838 125.291 291.027 123.34C290.217 121.389 290.004 119.242 290.418 117.171C290.831 115.1 291.851 113.197 293.349 111.704C294.847 110.21 296.755 109.193 298.832 108.781C300.91 108.369 303.063 108.581 305.02 109.389C306.977 110.197 308.65 111.566 309.827 113.322C311.004 115.078 311.632 117.142 311.632 119.254C311.632 122.086 310.503 124.802 308.495 126.804C306.486 128.807 303.762 129.932 300.922 129.932V129.932Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.84 202.986L355.784 197.06L361.273 202.541L366.761 201.82C368.436 201.601 370.136 201.928 371.608 202.753C373.08 203.577 374.245 204.854 374.928 206.394L377.016 211.127L379.56 214.687C380.678 216.27 382.268 217.462 384.104 218.093C385.94 218.724 387.929 218.762 389.788 218.202L398.847 227.233L401.346 238.427C401.702 240.015 402.565 241.446 403.806 242.503C405.046 243.56 406.598 244.188 408.227 244.291L410.967 244.46C412.101 244.528 413.182 244.962 414.048 245.695C414.914 246.428 415.517 247.422 415.768 248.527L416.786 252.976C416.93 253.601 417.264 254.166 417.744 254.593C418.223 255.02 418.824 255.288 419.463 255.36L425.47 256.126L426.514 267.524L430.084 271.084L452.28 273.628C453.277 273.744 454.288 273.622 455.229 273.274C456.17 272.925 457.015 272.359 457.694 271.622C458.373 270.885 458.867 269.998 459.137 269.033C459.406 268.069 459.442 267.055 459.242 266.074L456.618 253.163C455.879 249.495 454.069 246.126 451.415 243.482L380.283 172.598L386.227 166.681",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.649 79.79C307.065 82.4669 300.177 86.799 294.487 92.4699L277.11 109.794C271.417 115.461 267.068 122.326 264.383 129.887L263.946 131.132C260.673 140.354 260.461 150.382 263.343 159.733C266.224 169.084 272.046 177.263 279.948 183.062L304.697 201.241C308.994 204.396 314.284 205.912 319.606 205.512C324.927 205.112 329.929 202.823 333.703 199.061C334.505 198.262 335.456 197.627 336.504 197.194C337.551 196.762 338.674 196.539 339.808 196.539C340.942 196.539 342.065 196.762 343.112 197.194C344.16 197.627 345.111 198.262 345.913 199.061L349.831 202.967L386.218 166.689L382.3 162.783C381.498 161.984 380.861 161.035 380.427 159.991C379.993 158.947 379.77 157.827 379.77 156.697C379.77 155.566 379.993 154.447 380.427 153.403C380.861 152.358 381.498 151.41 382.3 150.611C385.976 146.949 388.255 142.123 388.743 136.966C389.232 131.808 387.9 126.642 384.977 122.359L367.725 97.1058C362.034 88.7854 353.742 82.5753 344.142 79.4433C334.542 76.3112 324.172 76.4333 314.649 79.79V79.79Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.648 147.399L310.284 143.047",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.396 177.056L316.862 149.596",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.355 158.041L356.355 156.047C358.022 154.379 358.959 152.12 358.959 149.765C358.959 147.41 358.022 145.151 356.355 143.483V143.483C354.682 141.823 352.418 140.891 350.058 140.891C347.698 140.891 345.434 141.823 343.761 143.483L325.242 161.92C323.57 163.58 321.306 164.512 318.946 164.512C316.586 164.512 314.322 163.58 312.649 161.92C310.981 160.252 310.045 157.993 310.045 155.638C310.045 153.283 310.981 151.024 312.649 149.356L314.648 147.363L337.46 124.619",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.844 172.518L352.142 160.248",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.543 180.785L337.63 174.725",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16 132.921L324.805 128.579",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.907 162.579L331.374 135.128",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.283 187.191L445.809 254.515",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.828 72.5023L76.2993 117.883C69.739 120.257 63.7811 124.037 58.8463 128.957C53.9115 133.877 50.1201 139.817 47.7395 146.357L2.22233 271.511C-5.07826 291.603 14.4406 311.054 34.5931 303.785L160.122 258.404C166.683 256.031 172.642 252.252 177.576 247.331C182.511 242.411 186.302 236.471 188.682 229.93L234.199 104.767C241.491 84.6842 221.981 65.2236 201.828 72.5023ZM219.08 100.585C217.789 101.871 216.145 102.746 214.355 103.101C212.565 103.455 210.71 103.273 209.025 102.576C207.339 101.879 205.898 100.7 204.884 99.1869C203.871 97.6741 203.33 95.8955 203.33 94.0761C203.33 92.2568 203.871 90.4782 204.884 88.9653C205.898 87.4524 207.339 86.2734 209.025 85.5768C210.71 84.8801 212.565 84.6972 214.355 85.0515C216.145 85.4058 217.789 86.2813 219.08 87.5671C219.938 88.4216 220.619 89.4365 221.083 90.5533C221.547 91.6702 221.786 92.8671 221.786 94.0761C221.786 95.2851 221.547 96.4825 221.083 97.5993C220.619 98.7162 219.938 99.7306 219.08 100.585Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.557 94.0801C246.918 59.8221 300.913 70.233 300.913 119.235",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.511 201.758L85.6975 243.446L72.0156 211.305L95.274 188.125L127.511 201.758Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.688 155.719L127.511 201.758L95.2737 188.126L141.46 142.078L173.688 155.719Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5515 163.549L70.2217 140.289",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1366 247.041L35.7979 270.309",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6936 188.134H42.9646",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4959 228.346L29.6221 244.042",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4218 174.44L65.4648 167.366",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7163 206.42L39.0381 213.753",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.294 129.229L200.633 105.969",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.211 142.745L118.22 113.114",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.552 124.61L174.295 99.811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.475 153.45L97.38 135.546",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.552 131.8L143.906 109.199",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.879 212.72L166.209 235.989",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.737 188.134H193.457",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.935 147.923L206.809 132.227",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.009 201.838L170.966 208.912",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.715 169.858L197.393 162.525",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.211 233.524V263.155",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8793 251.667L62.1357 276.467",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.955 222.829L139.051 240.732",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8786 244.469L92.5244 267.079",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M293.782 121.63C293.782 118.798 294.91 116.082 296.919 114.079C298.927 112.077 301.651 110.952 304.492 110.952C305.873 110.951 307.24 111.22 308.517 111.743C307.396 110.63 306.04 109.779 304.549 109.25C303.058 108.721 301.468 108.529 299.894 108.686C298.319 108.843 296.799 109.346 295.443 110.159C294.086 110.972 292.927 112.075 292.05 113.388C291.172 114.7 290.597 116.191 290.366 117.752C290.135 119.313 290.253 120.905 290.713 122.415C291.173 123.924 291.964 125.314 293.027 126.483C294.09 127.652 295.399 128.571 296.861 129.175C294.875 127.165 293.768 124.452 293.782 121.63Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M79.6367 229.271L85.67 243.446L127.483 201.758L173.661 155.718L161.88 150.727C160.88 156.671 157.569 165.738 147.154 173.737C129.884 186.995 121.066 180.42 114.908 196.437C109.259 211.208 99.6643 228.248 79.6367 229.271Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 306,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.668194fe3bc664368d1841be630be2a4.svg";
export { ForwardRef as ReactComponent };